"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initPowerPointPassportFromHeader = exports.generateOpenURLPowerPoint = exports.frameRateOptionsForEpicSourceForm = exports.PowerpointThumbnailImages = exports.PowerPointPassportHeaderDefault = exports.PowerPointPassportDefault = exports.NOT_SET = void 0;
var _uuid = require("uuid");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NOT_SET = exports.NOT_SET = "NOT_SET";
var initPowerPointPassportFromHeader = exports.initPowerPointPassportFromHeader = function initPowerPointPassportFromHeader(data) {
  return _objectSpread(_objectSpread({}, data), {}, {
    isConnected: true
  });
};
var PowerPointPassportHeaderDefault = exports.PowerPointPassportHeaderDefault = function PowerPointPassportHeaderDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    authCode: ""
  };
};
var PowerPointPassportDefault = exports.PowerPointPassportDefault = function PowerPointPassportDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    isConnected: false
  };
};
var scope = "offline_access https://graph.microsoft.com/Files.Read https://graph.microsoft.com/Files.Read.All https://graph.microsoft.com/Files.ReadWrite https://graph.microsoft.com/Files.ReadWrite.All https://graph.microsoft.com/Sites.Read.All https://graph.microsoft.com/Sites.ReadWrite.All https://graph.microsoft.com/User.Read https://microsoft.sharepoint.com/AllSites.Read https://microsoft.sharepoint.com/MyFiles.Read openid profile";
var generateOpenURLPowerPoint = exports.generateOpenURLPowerPoint = function generateOpenURLPowerPoint(codeChallenge, currentURL) {
  return "https://login.microsoftonline.com/common/oauth2/v2.0/authorize" + "?client_id=32756190-20dd-4820-83cf-949024884a8e" + "&response_type=code" + "&redirect_uri=https://integrations.userful.com/oauth2/microsoft/powerpoint" + "&response_mode=query" + "&scope=".concat(scope) + "&state=".concat(currentURL) + "&code_challenge=".concat(codeChallenge) + "&code_challenge_method=S256" + "&prompt=select_account";
};
var frameRateOptionsForEpicSourceForm = exports.frameRateOptionsForEpicSourceForm = [{
  value: "0.1",
  label: "0.1",
  id: "0.1"
}, {
  value: "0.5",
  label: "0.5",
  id: "0.5"
}, {
  value: "1",
  label: "1",
  id: "1"
}, {
  value: "5",
  label: "5",
  id: "5"
}, {
  value: "10",
  label: "10",
  id: "10"
}, {
  value: "25",
  label: "25",
  id: "25"
}, {
  value: "30",
  label: "30",
  id: "30"
}, {
  value: "45",
  label: "45",
  id: "45"
}, {
  value: "60",
  label: "60",
  id: "60"
}];
var PowerpointThumbnailImages = exports.PowerpointThumbnailImages = [{
  value: "/usr/share/userful-plugin-Powerpoint/icons/powerpoint-thumbnail.png",
  fileName: "powerpoint-thumbnail.png"
}, {
  value: "/usr/share/userful-plugin-Powerpoint/icons/system-logo.png",
  fileName: "system-logo.png"
}];